import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';

let analytics = null;

export const initAnalytics = (app) => {
  analytics = getAnalytics(app);
  
  // Track user location and device info
  if (analytics) {
    setUserProperties(analytics, {
      device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      browser: getBrowser(),
      screen_size: `${window.innerWidth}x${window.innerHeight}`,
    });
  }
};

const getBrowser = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Edge')) return 'Edge';
  return 'Other';
};

// Page view tracking
export const trackPageView = (pageName, pageParams = {}) => {
  if (!analytics) return;
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...pageParams,
  });
};

// Portfolio interactions
export const trackProjectClick = (projectId, projectTitle) => {
  if (!analytics) return;
  logEvent(analytics, 'select_content', {
    content_type: 'project',
    content_id: projectId,
    item_name: projectTitle,
  });
};

export const trackProjectView = (projectId, projectTitle) => {
  if (!analytics) return;
  logEvent(analytics, 'view_item', {
    content_type: 'project',
    content_id: projectId,
    item_name: projectTitle,
  });
};

// User engagement
export const trackButtonClick = (buttonName, location) => {
  if (!analytics) return;
  logEvent(analytics, 'button_click', {
    button_name: buttonName,
    click_location: location,
  });
};

export const trackServiceView = (serviceName) => {
  if (!analytics) return;
  logEvent(analytics, 'view_service', {
    service_name: serviceName,
  });
};

export const trackSectionView = (sectionName) => {
  if (!analytics) return;
  logEvent(analytics, 'section_view', {
    section_name: sectionName,
  });
};

// Contact interactions
export const trackContactClick = (method) => {
  if (!analytics) return;
  logEvent(analytics, 'contact_click', {
    contact_method: method,
  });
};

export const trackExternalLink = (linkName, url) => {
  if (!analytics) return;
  logEvent(analytics, 'external_link_click', {
    link_name: linkName,
    link_url: url,
  });
};

// Team member interactions
export const trackTeamMemberClick = (memberName) => {
  if (!analytics) return;
  logEvent(analytics, 'team_member_click', {
    member_name: memberName,
  });
};

// Scroll tracking
export const trackScrollDepth = (depth) => {
  if (!analytics) return;
  logEvent(analytics, 'scroll_depth', {
    scroll_percentage: depth,
  });
};

// Time on page
export const trackTimeOnPage = (pageName, timeInSeconds) => {
  if (!analytics) return;
  logEvent(analytics, 'page_engagement', {
    page_name: pageName,
    engagement_time: timeInSeconds,
  });
};

// Navigation tracking
export const trackNavigation = (from, to) => {
  if (!analytics) return;
  logEvent(analytics, 'navigation', {
    from_page: from,
    to_page: to,
  });
};

// Chatbot analytics
export const trackChatOpen = () => {
  if (!analytics) return;
  logEvent(analytics, 'chat_open', {
    timestamp: new Date().toISOString(),
  });
};

export const trackChatClose = () => {
  if (!analytics) return;
  logEvent(analytics, 'chat_close', {
    timestamp: new Date().toISOString(),
  });
};

export const trackChatMessage = (messageLength, isFirstMessage = false) => {
  if (!analytics) return;
  logEvent(analytics, 'chat_message_sent', {
    message_length: messageLength,
    is_first_message: isFirstMessage,
  });
};

export const trackChatResponse = (responseLength, responseTime) => {
  if (!analytics) return;
  logEvent(analytics, 'chat_response_received', {
    response_length: responseLength,
    response_time_ms: responseTime,
  });
};

export const trackChatError = (errorType) => {
  if (!analytics) return;
  logEvent(analytics, 'chat_error', {
    error_type: errorType,
  });
};

export const trackChatTopic = (topic) => {
  if (!analytics) return;
  logEvent(analytics, 'chat_topic', {
    topic: topic,
  });
};

export default analytics;
